import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';
import emptyUserImg from 'assets/images/emptyUserImg.png';

export default props => {
  let imgUrl = props.imgUrl;
  if (!props.imgUrl && props.userAvatar) {
    imgUrl = emptyUserImg;
  }

  return (
    <div
      className={classnames(styles.thumbnailImg, props.className, {
        [styles.large]: props.size === 'lg',
        [styles.alignMiddle]: props.alignMiddle,
        [styles.fillContainer]: props.fillContainer
      })}
      style={Object.assign(
        {
          backgroundImage: `url("${imgUrl}")`
        },
        props.style || {}
      )}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/util/imageThumbnail/index.js